if (!customElements.get('buyer-reviews-carousel')) {
  class BuyerReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.buyer-reviews__track');
      this.slides = Array.from(this.querySelectorAll('.buyer-reviews__slide'));
      this.dots = Array.from(this.querySelectorAll('.buyer-reviews__dot'));
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.currentIndex = 0;
      this.autoRotateEnabled = this.dataset.autoRotate === 'true';
      this.autoRotateSpeed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      this.onScroll = this.onScroll.bind(this);
      this.handleAutoplay = this.handleAutoplay.bind(this);
      this.pauseAutoplay = this.pauseAutoplay.bind(this);

      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      this.slider?.addEventListener('scroll', this.onScroll, { passive: true });
      this.slider?.addEventListener('touchstart', this.pauseAutoplay, { passive: true });
      this.addEventListener('mouseenter', this.pauseAutoplay);
      this.addEventListener('mouseleave', this.handleAutoplay);
      this.mobileQuery.addEventListener('change', () => {
        this.syncFromScroll();
        this.handleAutoplay();
      });

      this.syncFromScroll();
      this.handleAutoplay();
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }

    isMobile() {
      return this.mobileQuery.matches;
    }

    goTo(index) {
      if (!this.slider || !this.slides.length) return;

      const lastIndex = this.slides.length - 1;
      this.currentIndex = Math.max(0, Math.min(index, lastIndex));

      if (this.isMobile()) {
        const slide = this.slides[this.currentIndex];
        this.slider.scrollTo({
          left: slide.offsetLeft - this.getScrollInset(),
          behavior: 'smooth',
        });
      }

      this.updateDots();
      this.updateButtons();
    }

    getScrollInset() {
      const firstSlide = this.slides[0];
      return firstSlide ? firstSlide.offsetLeft : 0;
    }

    syncFromScroll() {
      if (!this.slider || !this.slides.length) return;

      if (!this.isMobile()) {
        this.currentIndex = 0;
        this.updateDots();
        this.updateButtons();
        return;
      }

      const scrollPosition = this.slider.scrollLeft + this.getScrollInset();
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollPosition);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.currentIndex = closestIndex;
      this.updateDots();
      this.updateButtons();
    }

    onScroll() {
      this.syncFromScroll();
      this.pauseAutoplay();
      clearTimeout(this.scrollResumeTimeout);
      this.scrollResumeTimeout = setTimeout(this.handleAutoplay, 3000);
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('buyer-reviews__dot--active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    updateButtons() {
      if (!this.prevButton || !this.nextButton) return;

      this.prevButton.toggleAttribute('disabled', this.currentIndex === 0);
      this.nextButton.toggleAttribute('disabled', this.currentIndex >= this.slides.length - 1);
    }

    handleAutoplay() {
      this.pauseAutoplay();

      if (!this.autoRotateEnabled || !this.isMobile() || this.slides.length < 2) return;

      this.autoplayTimer = setInterval(() => {
        if (this.currentIndex >= this.slides.length - 1) {
          this.goTo(0);
        } else {
          this.goTo(this.currentIndex + 1);
        }
      }, this.autoRotateSpeed);
    }

    pauseAutoplay() {
      clearInterval(this.autoplayTimer);
      clearTimeout(this.scrollResumeTimeout);
    }
  }

  customElements.define('buyer-reviews-carousel', BuyerReviewsCarousel);
}
